import ItemTipoClasificacion from './itemtipoclasificacion.vue';
import ItemTipoClasificacionForm from './itemtipoclasificacion-form.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

var routes = [{
        path: '/itemtipoclasificacion/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('itemtipoclasificacion', ['ADMIN', 'DTYCAL'], ItemTipoClasificacion),
        keepAlive: true
    },
    {
        path: '/itemtipoclasificacion/new/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('itemtipoclasificacion/new', ['ADMIN', 'DTYCAL'], ItemTipoClasificacionForm)
    },
    {
        path: '/itemtipoclasificacion/edit/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('itemtipoclasificacion/edit', ['ADMIN', 'DTYCAL'], ItemTipoClasificacionForm)
    },
    {
        path: '/itemtipoclasificacion/view/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('itemtipoclasificacion/view', ['ADMIN', 'DTYCAL'], ItemTipoClasificacionForm, { editable: false })
    },
];
export default routes;
